import { ChangeDetectionStrategy, Component, input, InputSignal, computed, inject } from '@angular/core';
import { OrderShipment } from './../../../../models/';
import { LineStatus, MediaType, OrderScreen, OrderType } from '../../../../models/enums';
import { OrderUtilityService } from '../../../../services';
import { OrderComponent } from '../../../../shared/components/order/order.component';

@Component({
  selector: 'insight-order-shipment-details-board',
  templateUrl: './order-shipment-details-board.component.html',
  styleUrls: ['./order-shipment-details-board.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrderComponent]
})
export class OrderShipmentDetailsBoardComponent {
  public orderShipment: InputSignal<OrderShipment> = input.required<OrderShipment>();
  public orderScreen = OrderScreen;
  public lineStatuses = LineStatus;

  // Injected services
  public orderUtilityService = inject(OrderUtilityService);

  public readonly isAnyCompleteOrder = computed(() => {
    return this.isCompleteAdebsOrder() || this.isCompleteStreamingOrder() || this.isCompleteCinelinkOrder();
  });

  public readonly isCompleteAdebsOrder = computed(() => {
    const validMediaTypes = [MediaType.HardDrive, MediaType.Cvd, MediaType.NetworkDelivery];
    return this.isCompletedOrder() &&
      this.orderShipment().orderType === OrderType.Adebs &&
      validMediaTypes.includes(this.orderShipment().mediaType);
  });

  private readonly isCompleteStreamingOrder = computed(() => {
    return this.isCompletedOrder() && this.orderShipment().orderType === OrderType.StreamingServer;
  });

  private readonly isCompleteCinelinkOrder = computed(() => {
    return this.isCompletedOrder() && this.orderShipment().orderType === OrderType.Cinelink;
  });

  private readonly isCompletedOrder = computed(() => {
    return this.orderShipment().lines.every(l =>
      [LineStatus.Complete, LineStatus.Cancelled, LineStatus.Shipped].includes(l.status)
    );
  });
}
